import React from 'react';
import { Drawer } from 'antd';
import { DrawerProps as DrawerCopyProps } from 'antd/lib/drawer';

export type DrawerProps = DrawerCopyProps;

const ProDrawer: React.FC<DrawerProps> = (props) => {
  const { children, ...resProps } = props;

  return <Drawer {...resProps}>{children}</Drawer>;
};

export default ProDrawer;
